export default {"src":"/_next/static/media/globe.8b05b849.svg","height":463,"width":517};